export class RuleCompilationResult {
  compilationErrors: string;
  showErrors: boolean;
  toggleErrorLabel: ('SHOW_ERRORS' | 'HIDE_ERRORS');
  constructor() {
    this.showErrors = true;
    this.toggleErrorLabel = 'HIDE_ERRORS';
  }
  isOk(): boolean {
    return this.compilationErrors == null;
  }
  toggleErrorVisibility(): void {
    this.showErrors = !this.showErrors;
    if (this.showErrors === true) {
      this.toggleErrorLabel = 'HIDE_ERRORS';
    }
    else {
      this.toggleErrorLabel = 'SHOW_ERRORS';
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/classes/rule.class.ts